module.exports = __webpack_public_path__ + "static/process-3-f67daced2004b74de968c7f1b6b9eb88.svg";